
import { Link } from 'ca-api-client';
import download from '@/components/links/mixins/download';

export default {
    mixins: [download],
    methods: {
        async doDownloadQRCode(event) {
            const type = event.type;
            const link = await Link.forUrl({
                client_id: this.client.uuid,
                project_id: this.project.uuid,
                long_url: event.value,
                title: event.title,
            });

            let url = event.type === 'png' ? link.qr_png_url : link.qr_svg_url;

            this.doDownload(link.short_code, type, url);
        },
    },
};
